var map = {
	"./404_1.svg": 90,
	"./404_2.svg": 85764,
	"./VIP.svg": 60566,
	"./about.svg": 98061,
	"./add.svg": 59614,
	"./android.svg": 9357,
	"./archive.svg": 59706,
	"./article.svg": 38562,
	"./audit.svg": 43864,
	"./baidu.svg": 65909,
	"./bili.svg": 13829,
	"./bozhu.svg": 49977,
	"./car.svg": 28707,
	"./chrome.svg": 88733,
	"./collapse.svg": 41557,
	"./collect.svg": 90825,
	"./collection.svg": 58985,
	"./comment.svg": 45979,
	"./copyright.svg": 67645,
	"./csdn.svg": 53393,
	"./doc.svg": 38839,
	"./edge.svg": 29753,
	"./edit.svg": 48352,
	"./email.svg": 51533,
	"./empty.svg": 22025,
	"./excel.svg": 99139,
	"./expand.svg": 87227,
	"./feedback.svg": 98037,
	"./friend.svg": 60978,
	"./friendLink.svg": 5660,
	"./gitee.svg": 35167,
	"./github.svg": 89460,
	"./google.svg": 94512,
	"./guanfang.svg": 86350,
	"./guanzhume.svg": 27633,
	"./home.svg": 49429,
	"./hot.svg": 68399,
	"./hot2.svg": 58211,
	"./level1.svg": 38109,
	"./link.svg": 14121,
	"./lock.svg": 96648,
	"./love.svg": 14724,
	"./mac.svg": 68926,
	"./message.svg": 30860,
	"./navication.svg": 16909,
	"./note.svg": 12280,
	"./notice.svg": 91543,
	"./pdf.svg": 26500,
	"./photo.svg": 45249,
	"./qq.svg": 56869,
	"./qqgroup.svg": 3415,
	"./resources.svg": 70829,
	"./safari.svg": 55943,
	"./say.svg": 59488,
	"./shandian.svg": 46307,
	"./sign1.svg": 53889,
	"./sponsor.svg": 52106,
	"./sxdianzan.svg": 22667,
	"./tag.svg": 64205,
	"./talk.svg": 29344,
	"./topNotice.svg": 64250,
	"./tuijian.svg": 36476,
	"./watch.svg": 40850,
	"./weather.svg": 44831,
	"./wechat.svg": 70267,
	"./weibo.svg": 19248,
	"./wexin.svg": 20940,
	"./windowns.svg": 54136,
	"./xiangqing.svg": 17408,
	"./xkxy.svg": 74377,
	"./yuan.svg": 95276,
	"./yuanchuang.svg": 22202,
	"./zhihu.svg": 26908,
	"./zip.svg": 47276,
	"./zzlink.svg": 66403,
	"./交友.svg": 58643,
	"./任务.svg": 25447,
	"./即时聊天.svg": 72046,
	"./心动.svg": 99319,
	"./恋爱.svg": 96382,
	"./恋爱星球.svg": 25981,
	"./恋爱空间.svg": 15134,
	"./直播间.svg": 85229,
	"./礼物.svg": 15822,
	"./认证.svg": 13543,
	"./通告.svg": 40232,
	"./音乐.svg": 31414
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;